import { Button, DatePicker, Input, Modal, Select, Table } from 'antd'
import { Option } from 'antd/es/mentions'
import React, { useState, useEffect } from 'react'
// import "../../MainCSS.css";
import 'aos/dist/aos.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import TextArea from 'antd/es/input/TextArea'
import { RackMasterGet } from '../../AllAPI/MasterAPI/ProductionMasterApi'
import {
  GetAllDataByItemId,
  GetAllocationTypeData,
  GetAllPackingData,
  GetBarcodeData,
  GetBundleData,
  GetItemNamesDataByRackId,
  GetRackData,
  RackRelease,
  SaveAllPackingData,
  UpdateAllPackingData,
} from '../../AllAPI/ProductionAPI/ProductionApi'
import { BaseIPForPDF } from '../../AllAPI/CommonAPI/CommonApi'

const Packing = () => {
  const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {}
  // const storedUserData = sessionStorage.getItem('userData') || '';

  const commonHeaders = {
    headers: {
      // createdBy: storedUserData || '',
      // updatedBy: storedUserData || '',
      createdBy: 1,
      updatedBy: 2,
      userIp: storedHeaders.userIp || '',
      userLat: storedHeaders.userLat || '',
      userLong: storedHeaders.userLong || '',
      deviceSign: storedHeaders.deviceSign || '',
    },
  }

  const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }

  const [errors, setErrors] = useState({
    pressNumber: '',
    wtPerPcs: '',
    rackNumber: '',
    allPendingOrderId: '',
    lengthSize: '',
    unit: '',
    dieNumber: '',
    dieSubNumber: '',
    wtRange: '',
    quantity: '',
    dieName: '',
    totalPcs: '',
    outputRemark: '',
  })
  const [errorsM, setErrorsM] = useState({
    packingIdM: '',
    lengthSizeM: '',
    unitM: '',
    pcsM: '',
    alloyM: '',
    temperM: '',
    netWeightM: '',
    wtRangeM: '',
  })

  const [allRackNumber, setAllRackNumber] = useState([])
  const [allItemName, setAllItemName] = useState([])
  const [allAllocationType, setAllAllocationType] = useState([])

  const [rackNumber, setRackNumber] = useState('')
  const [dieNumber, setDieNumber] = useState('')
  const [dieSubNumber, setDieSubNumber] = useState('')
  const [itemName, setItemName] = useState('')
  const [alloy, setAlloy] = useState('')
  const [temper, setTemper] = useState('')
  const [lengthSize, setLengthSize] = useState('')
  const [unit, setUnit] = useState('')
  const [pcs, setPcs] = useState('')
  const [pcsHead, setPcsHead] = useState('')
  const [netWeightHead, setNetWeightHead] = useState('')
  const [grossWeight, setGrossWeight] = useState('')
  const [netWeight, setNetWeight] = useState('')
  const [weightRange, setWeightRange] = useState('')
  const [pressOutputId, setPressOutputId] = useState('')
  const [barcodeSize, setBarcodeSize] = useState('')
  const [allocation, setAllocation] = useState('')
  const [allocationType, setAllocationType] = useState('')
  const [rackNumberId, setRackNumberId] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [color, setColor] = useState('')
  const [colorName, setColorName] = useState('')
  const [colorCode, setColorCode] = useState('')

  const [rackRelease, setRackRelease] = useState('')

  const [packingId, setPackingId] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false);
  
  const [packingIdM, setPackingIdM] = useState('')
  const [alloyM, setAlloyM] = useState('')
  const [temperM, setTemperM] = useState('')
  const [lengthSizeM, setLengthSizeM] = useState('')
  const [unitM, setUnitM] = useState('')
  const [pcsM, setPcsM] = useState('')
  const [netWeightM, setNetWeightM] = useState('')
  const [weightRangeM, setWeightRangeM] = useState('')

  // Fetch OrderEntry, Customer and Item Names
  let isPackingDataFetched = false
  useEffect(() => {
    if (isPackingDataFetched) return
    fetchRackNumber();
    fetchTodaysPackingData();
    fetchBundleData();
    isPackingDataFetched = true
  }, [])

  const handlePackingCancel = () => {
    setRackNumber("")
    setDieNumber('')
    setDieSubNumber('')
    setItemName()
    setAlloy('')
    setTemper('')
    setLengthSize('')
    setUnit('')
    setPcs('')
    setPcsHead('')
    setNetWeight('')
    setNetWeightHead('')
    setGrossWeight('')
    setWeightRange('')
    setBarcodeSize('')
    setAllocation('')
    setAllocationType('')
    setCustomerName('')
    setColor('')
    setColorName('')
    setColorCode('')

    setErrors('')
  }
  const handlePackingCancel1 = () => {
    setRackNumber("")
    setDieNumber('')
    setDieSubNumber('')
    setItemName()
    setAlloy('')
    setTemper('')
    setLengthSize('')
    setUnit('')
    setPcs('')
    setPcsHead('')
    setNetWeight('')
    setNetWeightHead('')
    setGrossWeight('')
    setWeightRange('')
    setBarcodeSize('')
    setAllocation('')
    setAllocationType('')
    setCustomerName('')
    setColor('')
    setColorName('')
    setColorCode('')

    setErrors('')
  }
  const handlePackingCancel2 = () => {
    setPackingIdM('')
    setLengthSizeM('')
    setUnitM('')
    setPcsM('')
    setAlloyM('')
    setTemperM('')
    setNetWeightM('')
    setWeightRangeM('')

    setErrorsM('')
  }
  //=========================================
  let isError = false

  const fetchRackNumber = async () => {
    try {
      const response = await axios.get(GetRackData, commonHeaders1)
      if (response.data !== null) {
        setAllRackNumber(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Rack Number:', error)
        toast.error('Failed to fetch Rack Number data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  // 1. When Rack Number selected => fetch Item Names
  const handleRackChange = async (rackId) => {
    setRackNumber(rackId)
    setItemName(null)
    handlePackingCancel1()

    try {
      const res = await axios.get(
        `${GetItemNamesDataByRackId}?rackNumberId=${rackId}`,
        commonHeaders1,
      )
      setAllItemName(res.data)
      
    } catch (err) {
      console.error('Error fetching item names', err)
    }
  }

  // 2. When Item Name selected => fetch full item details
  const handleItemNameChange = async (itemId) => {
    setItemName(itemId)
    setPressOutputId(itemId)
  
    try {
      const res = await axios.get(
        `${GetAllDataByItemId}?pressOutputId=${itemId}`,
        commonHeaders1,
      )
      const data = res.data[0]

      // Fill all fields
      setDieNumber(data.dieNumber)
      setDieSubNumber(data.dieSubNumber)
      setAlloy(data.alloyName || "NA")
      setTemper(data.temperName || "NA")
      setLengthSize(data.length)
      // setUnit(data.unit)
      setUnit(data.unit ? String(data.unit) : null)
      setPcsHead(data.totalPcs)
      setNetWeightHead(parseFloat(data.qty).toFixed(2))
      setGrossWeight(data.grossWeight)
      setWeightRange(data.wtRange)
      setPressOutputId(data.id)
      setBarcodeSize(data.barcodeSize || '1')
      setAllocation(data.allocation || '1')
      setRackNumberId(data.rackNumberId)
      setCustomerName(data.customerName)
      setColorName(data.colorName)
      setColor(data.color)
      setColorCode(data.colorCode)
      const diaId = data.dieNameId
      const alloyId = data.alloyId
      const temperId = data.temperId

      // Fetch Allocation Type dropdown
      const allocationRes = await axios.get(
        `${GetAllocationTypeData}?dieNameId=${diaId}&alloyId=${alloyId}&temperId=${temperId}`,
        commonHeaders1,
      )
      setAllAllocationType(allocationRes.data)
      setFilteredData2(allocationRes.data); 
      setTotalEntries2(allocationRes.data.length);
    } catch (err) {
      console.error('Error fetching item details', err)
    }
  }

  // 3. Submit Button=======================================================================
  const handlePackingSubmit = async () => {
    let isValid = true
    const errorObj = {}

    if (!itemName) {
      isValid = false
      errorObj.itemName = 'Item Name is required *'
    }
    if (!alloy) {
      isValid = false
      errorObj.alloy = 'Alloy is required *'
    }
    if (!temper) {
      isValid = false
      errorObj.temper = 'Temper is required *'
    }
    if (!lengthSize) {
      isValid = false
      errorObj.lengthSize = 'Length is required *'
    }
    if (!unit) {
      isValid = false
      errorObj.unit = 'Unit is required *'
    }
    if (!pcs) {
      isValid = false
      errorObj.pcs = 'Pcs is required *'
    }
    if (!weightRange) {
      isValid = false
      errorObj.weightRange = 'Weight Range is required *'
    }
    if (!netWeight) {
      isValid = false
      errorObj.netWeight = 'Net Weight is required *'
    }
    if (!barcodeSize) {
      isValid = false
      errorObj.barcodeSize = 'Barcode Size is required *'
    }
    if (!allocation) {
      isValid = false
      errorObj.allocation = 'Allocation is required *'
    }

    setErrors(errorObj) // Set error messages

    if (!isValid) return

    const payload = {
      pcs: parseFloat(pcs),
      alloyName: alloy,
      temperName: temper,
      length: parseFloat(lengthSize),
      unit: parseFloat(unit),
      netWeight: parseFloat(netWeight),
      grossWeight: parseFloat(grossWeight),
      weightRange: parseFloat(weightRange),
      barcodeSize: parseFloat(barcodeSize),
      allocation: parseFloat(allocation),
      pressOutputId: parseFloat(pressOutputId),
      allocationType: parseFloat(allocationType),
      rackNumberId: parseFloat(rackNumberId),
    }

    try {
      const response = await axios.post(
        SaveAllPackingData,
        payload,
        commonHeaders,
      )
      if (response.data == 'CREATED') {
        toast.success('Data submitted successfully!')
        handlePackingCancel();
        fetchTodaysPackingData();
        fetchBundleData();
      }
      else if (response.data == "ALREADYEXISTED") {
        toast.warn('Data Already Exist!')
      }
    } catch (err) {
      console.error('Error submitting data', err)
    }
  }

  //===========================================
  const unitOptions = [
    { value: '1', label: 'FT' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'INCH' },
  ]
  const barcodeOptions = [
    { value: '1', label: 'Big' },
    { value: '2', label: 'Small' },
  ]
  const allocationOptions = [
    { value: '1', label: 'Yes' },
    { value: '2', label: 'No' },
  ]
  //===============================================

  //======Todays Packing Details Data Table===============

  const [todaysPackingData, setTodaysPackingData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [pageSize, setPageSize] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)

  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = todaysPackingData.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  const fetchTodaysPackingData = async () => {
    try {
      const response = await axios.get(GetAllPackingData, commonHeaders1)
      if (response.data !== null) {
          setTodaysPackingData(response.data);
          setFilteredData(response.data); // Default filtered list = full list
          setTotalEntries(response.data.length);
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Todays Packing Data:', error)
        toast.error('Failed to fetch Todays Packing Data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }


  const columns = [
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'Pack Time',
    dataIndex: 'packTime',
    key: 'packTime',
    sorter: (a, b) => String(a.packTime ?? '').localeCompare(String(b.packTime ?? '')),
  },
  {
    title: 'Packing Id',
    dataIndex: 'packingId',
    key: 'packingId',
    sorter: (a, b) => String(a.packingId ?? '').localeCompare(String(b.packingId ?? '')),
  },
  {
    title: 'Order No',
    dataIndex: 'orderNumber',
    key: 'orderNumber',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => String(a.orderNumber ?? '').localeCompare(String(b.orderNumber ?? '')),
  },
  {
    title: 'Rack No',
    dataIndex: 'rackNumber',
    key: 'rackNumber',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => String(a.rackNumber ?? '').localeCompare(String(b.rackNumber ?? '')),
  },
  {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => String(a.dieName ?? '').localeCompare(String(b.dieName ?? '')),
  },
   {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
    render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.alloyName ?? '').localeCompare(String(b.alloyName ?? '')),
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
    render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.temperName ?? '').localeCompare(String(b.temperName ?? '')),
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
  },
  {
    title: 'Unit',
    dataIndex: 'unit',
    key: 'unit',
    render: (text) => (text === 1 ? "FT" : text === 0 ? "MM" : text === 2 ? "INCH" : "-"),
    sorter: (a, b) => (a.unit ?? 0) - (b.unit ?? 0),
  },
  {
    title: 'PCS',
    dataIndex: 'pcs',
    key: 'pcs',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
  },
  {
    title: 'Net Wt',
    dataIndex: 'netWeight',
    key: 'netWeight',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => (a.netWeight ?? 0) - (b.netWeight ?? 0),
  },
  {
    title: 'Wt Range',
    dataIndex: 'weightRange',
    key: 'weightRange',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => String(a.weightRange ?? '').localeCompare(String(b.weightRange ?? '')),
  },
 
  {
    title: 'Allocation',
    key: 'allocationCustomer',
    sorter: (a, b) => {
      const textA = a.allocation === 1 ? `Yes - ${a.customerName ?? ''}` : 'No';
      const textB = b.allocation === 1 ? `Yes - ${b.customerName ?? ''}` : 'No';
      return textA.localeCompare(textB);
    },
    render: (text, record) => {
      const allocationText = record.allocation === 1 ? 'Yes' : 'No';
      const customerName = record.allocation === 1 ? "- " + (record.customerName ?? '') : '';
      return `${allocationText} ${customerName}`;
    },
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (text, record) => (
      <div className='d-flex'>     
        <span
          type="submit"
          style={{ fontSize: '12px', color: '#349ff3', marginRight: '0px' }}
          onClick={() => handleGenerateBarcode(record)}
        >
          <Button style={{ padding: "3px", backgroundColor: "#000", color: "#fff" }}>Barcode</Button>
        </span>

        <span
              type="submit"
              onClick={() => handleEditClick(record)}
            >
              <Button  style={{
                padding: "3px 5px",
                marginLeft: "10px",
                backgroundColor:
                  record.allocation === 0 || record.allocation === 1 ? "#ccc" : "#349ff3",
                color:
                  record.allocation === 0 || record.allocation === 1 ? "#666" : "#000",
                cursor:
                  record.allocation === 0 || record.allocation === 1 ? "not-allowed" : "pointer",
              }} 
               disabled={record.allocation === 0 || record.allocation === 1}>Edit</Button>
            </span>

      </div>
    ),
  },
];


  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023e7d',
            color: '#fff',
            padding: '10px',
            fontSize: '15px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
            fontSize:'15px'
          }}
        >
          {children}
        </td>
      ),
    },
  }

   //======Todays Packing Details Data Table===============

   const [bundleData, setBundleData] = useState([])
   const [filteredData1, setFilteredData1] = useState([])
   const [viewMoreClicked, setViewMoreClicked] = useState(false);
   const [pageSize1, setPageSize1] = useState(10)
   const [currentPage1, setCurrentPage1] = useState(1)
   const [totalEntries1, setTotalEntries1] = useState(0)
 
 
   const handleSearch1 = (value) => {
     const searchValue = value.toLowerCase();
   
     const filtered = bundleData.filter((item) =>
       Object.values(item).some((val) =>
         String(val ?? "").toLowerCase().includes(searchValue)
       )
     );
   
     setFilteredData1(filtered);
     setTotalEntries1(filtered.length);
     setCurrentPage1(1);
   };
   
 
  //  const handlePageSizeChange1 = (value) => {
  //    setPageSize1(value)
  //  }
 
   const fetchBundleData = async () => {
     try {
       const response = await axios.get(GetBundleData, commonHeaders1)
       if (response.data !== null) {
           setBundleData(response.data);
           setFilteredData1(response.data); 
           setTotalEntries1(response.data.length);
       }
     } catch (error) {
       if (!isError) {
         console.error('Error fetching Bundle Data:', error)  
         toast.error('Failed to fetch Bundle Data')
         isError = true // Set the flag to prevent double toast
       }
     }
   }
 

  const columns1 = [ 
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => (currentPage1 - 1) * pageSize1 + index + 1,
  },
  {
    title: 'Packing Id',
    dataIndex: 'packingId',
    key: 'packingId',
    sorter: (a, b) => String(a.packingId ?? '').localeCompare(String(b.packingId ?? '')),
  },
  {
    title: 'Rack No',
    dataIndex: 'rackNumber',
    key: 'rackNumber',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => String(a.rackNumber ?? '').localeCompare(String(b.rackNumber ?? '')),
  },
  {
    title: 'Customer Name',
    dataIndex: 'customerName',
    key: 'customerName',
    sorter: (a, b) => String(a.customerName ?? '').localeCompare(String(b.customerName ?? '')),
  },
  {
    title: 'Pcs/Bundle',
    dataIndex: 'pcsPerBundle',
    key: 'pcsPerBundle',
    sorter: (a, b) => (a.pcsPerBundle ?? 0) - (b.pcsPerBundle ?? 0),
  },
  {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => String(a.dieName ?? '').localeCompare(String(b.dieName ?? '')),
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
  },
  
  {
    title: 'PCS',
    dataIndex: 'pcs',
    key: 'pcs',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
  },
  {
    title: 'Net Wt',
    dataIndex: 'netWeight',
    key: 'netWeight',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => (a.netWeight ?? 0) - (b.netWeight ?? 0),
  },
  {
    title: 'Wt Range',
    dataIndex: 'weightRange',
    key: 'weightRange',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => String(a.weightRange ?? '').localeCompare(String(b.weightRange ?? '')),
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
    render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.alloyName ?? '').localeCompare(String(b.alloyName ?? '')),
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
    render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.temperName ?? '').localeCompare(String(b.temperName ?? '')),
  },
  {
    title: 'Allocation',
    key: 'allocationCustomer',
    render: (text, record) => {
      const allocationText = record.allocation === 1 ? 'Yes' : 'No';
      const customerName = record.allocation === 1 ? '- ' + (record.customerName ?? '') : '';
      return `${allocationText} ${customerName}`;
    },
    sorter: (a, b) => {
      const aText = a.allocation === 1 ? 'Yes' + (a.customerName ?? '') : 'No';
      const bText = b.allocation === 1 ? 'Yes' + (b.customerName ?? '') : 'No';
      return aText.localeCompare(bText);
    }
  },
];  
 
   const components1 = {
     header: {
       cell: ({ children, ...restProps }) => (
         <th
           {...restProps}
           style={{
             backgroundColor: '#023e7d',
             color: '#fff',
             padding: '10px',
             fontSize: '15px',
             borderRadius: '0px',
           }}
         >
           {children}
         </th>
       ),
     },
     body: {
       row: ({ children, ...restProps }) => (
         <tr
           {...restProps}
           style={{
             backgroundColor: '#f0f7fd',
           }}
         >
           {children}
         </tr>
       ),
       cell: ({ children, ...restProps }) => (
         <td
           {...restProps}
           style={{
             padding: '8px',
             fontSize:'15px'
           }}
         >
           {children}
         </td>
       ),
     },
   }

   const handleViewMoreClick = () => {
  setViewMoreClicked(true);
  setPageSize1(10); // or any default page size
  setCurrentPage1(1); // reset to first page
};

const handleShowLessClick = () => {
  setViewMoreClicked(false);
  setPageSize1(10);
  setCurrentPage1(1);
};


const handlePageSizeChange1 = (value) => {
  setPageSize1(value);
  setCurrentPage1(1);
};


  const displayedData1 = viewMoreClicked
  ? [...filteredData1].reverse() // show all in reverse order
  : [...filteredData1].slice(-10).reverse(); // show last 10 in reverse order



  //===============================================

     //======Todays Packing Details Data Table===============

     const [filteredData2, setFilteredData2] = useState([])
     const [pageSize2, setPageSize2] = useState(10)
     const [currentPage2, setCurrentPage2] = useState(1)
     const [totalEntries2, setTotalEntries2] = useState(0)
   
     const handleSearch2 = (value) => {
       const searchValue = value.toLowerCase();
     
       const filtered = allAllocationType.filter((item) =>
         Object.values(item).some((val) =>
           String(val ?? "").toLowerCase().includes(searchValue)
         )
       );
     
       setFilteredData2(filtered);
       setTotalEntries2(filtered.length);
       setCurrentPage2(1);
     }; 
   
     const handlePageSizeChange2 = (value) => {
       setPageSize2(value)
     }
   

    const columns2 = [ 

  {
  title: 'Select',
  dataIndex: 'select',
  key: 'select',
  render: (text, record) => (
    <input
      type="checkbox"
      checked={allocationType === record.id}
      onChange={(e) => {
        if (allocationType === record.id) {
          setAllocationType(null); // Uncheck
        } else {
          setAllocationType(record.id); // Check
        }
      }}
      onClick={(e) => e.stopPropagation()} // Prevent row click when clicking checkbox
    />
  ),
},

  {
    title: 'Order No.',
    dataIndex: 'orderNumber',
    key: 'orderNumber',
    sorter: (a, b) => String(a.orderNumber ?? '').localeCompare(String(b.orderNumber ?? '')),
  },
  {
    title: 'Customer Name',
    dataIndex: 'customerName',
    key: 'customerName',
    sorter: (a, b) => String(a.customerName ?? '').localeCompare(String(b.customerName ?? '')),
  },
  {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => String(a.dieName ?? '').localeCompare(String(b.dieName ?? '')),
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
     render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.alloyName ?? '').localeCompare(String(b.alloyName ?? '')),
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
     render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.temperName ?? '').localeCompare(String(b.temperName ?? '')),
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
  },
   {
    title: 'Unit',
    dataIndex: 'unit',
    key: 'unit',
    render: (text) => (text === 1 ? "FT" : text === 0 ? "MM" : text === 2 ? "INCH" : "-"),
    sorter: (a, b) => (a.unit ?? 0) - (b.unit ?? 0),
  },
  {
    title: 'PCS',
    dataIndex: 'pcs',
    key: 'pcs',
    sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
  },
  {
    title: 'Wt Range',
    dataIndex: 'wtRange',
    key: 'wtRange',
    sorter: (a, b) => String(a.wtRange ?? '').localeCompare(String(b.wtRange ?? '')),
  },
  {
    title: 'Packing Remark',
    dataIndex: 'packingRemark',
    key: 'packingRemark', // NOTE: You might want to change this key to 'packingRemark' for clarity
    sorter: (a, b) => String(a.packingRemark ?? '').localeCompare(String(b.packingRemark ?? '')),
  },
  {
  title: 'Sticker Code',
  dataIndex: 'stickerCode',
  key: 'stickerCode',
  render: (text, record) => (
    <div
      style={{
        backgroundColor: record.color || 'transparent',
        padding: '4px 8px',
        borderRadius: '4px',
      }}
      title={record.colorName || ''}
    >
      {text || 'NA'}
    </div>
  ),
  sorter: (a, b) => String(a.stickerCode ?? '').localeCompare(String(b.stickerCode ?? '')),
  },

    ];

   
     const components2 = {
       header: {
         cell: ({ children, ...restProps }) => (
           <th
             {...restProps}
             style={{
               backgroundColor: '#023e7d',
               color: '#fff',
               padding: '10px',
               fontSize: '15px',
               borderRadius: '0px',
             }}
           >
             {children}
           </th>
         ),
       },
       body: {
         row: ({ children, ...restProps }) => (
           <tr
             {...restProps}
             style={{
               backgroundColor: '#f0f7fd',
             }}
           >
             {children}
           </tr>
         ),
         cell: ({ children, ...restProps }) => (
           <td
             {...restProps}
             style={{
               padding: '8px',
               fontSize:'15px'
             }}
           >
             {children}
           </td>
         ),
       },
     }

     //===Edit Todays Entry====
     const handleEditClick = async (item) => {      
      setPackingIdM(item.packingId)
      setAlloyM(item.alloyName);
      setTemperM(item.temperName);
      setLengthSizeM(item.length);
      setUnitM(item.unit ? String(item.unit) : null)
      setPcsM(item.pcs);
      setNetWeightM(item.netWeight);
      setWeightRangeM(item.weightRange);
      setIsModalVisible(true);
    };

    const handlePackingUpdate = async () => {

       const newErrors = {};
        if (!lengthSizeM) newErrors.lengthSizeM = "Length is required";
        if (!unitM) newErrors.unitM = "Unit is required";
        if (!pcsM) newErrors.pcsM = "Pcs is required";
        if (!netWeightM) newErrors.netWeightM = "Net weight is required";
        if (!weightRangeM) newErrors.weightRangeM = "Weight range is required";
        if (!alloyM) newErrors.alloyM = "Alloy is required";
        if (!temperM) newErrors.temperM = "Temper is required";

          setErrorsM(newErrors);

          if (Object.keys(newErrors).length > 0) return;
  
      const payload = {
        packingId: parseFloat(packingIdM),
        pcs: parseFloat(pcsM),
        netWeight: parseFloat(netWeightM),
        length: parseFloat(lengthSizeM),
        unit: parseFloat(unitM),
        alloyName: alloyM,
        temperName: temperM,
        weightRange: parseFloat(weightRangeM),
      }
  
      try {
        const response = await axios.put(
          UpdateAllPackingData,
          payload,
          commonHeaders,
        )
        if (response.data == 'UPDATED') {
          toast.success('Data updated successfully!')
           setIsModalVisible(false);
          fetchTodaysPackingData();
        }
        else if (response.data == "ALREADYEXISTED") {
          toast.warn('Data Already Exist!')
        }
      } catch (err) {
        console.error('Error submitting data', err)
      }
    }
    
  //===============================================

  const handleReleaseRack = async () => {

    let isValid = true
    const errorObj = {}

    if (!rackRelease) {
      isValid = false
      errorObj.rackRelease = 'Rack Number is required *'
    }

    setErrors(errorObj) // Set error messages

    if (!isValid) return
  
    try {
      const response = await axios.put(`${RackRelease}?rackNumberId=${rackRelease}`,null,commonHeaders);
      if (response.data == "UPDATED") {
        toast.success('Rack released successfully!');
        setRackRelease(null);
        fetchRackNumber();
      }
      else{
        toast.error('Error Occurred While Rack Release!');
      }
      
    } catch (error) {
      console.error('Release failed:', error);
      toast.error('Failed to release the rack');
    }
  };
//==========GENERATE BARCODE===============

  const handleGenerateBarcode = async(record) => {

    const { barcodeSize, packingId } = record;

  try{
    
    const url = `${GetBarcodeData}?packingId=${packingId}&barcodeSize=${barcodeSize}`;

    const response = await axios.get(url, commonHeaders);
    
    if (response.data !== null) {
      if (response.data === "NOTFOUND" || response.data === "NODATA" || response.status === 204) {
        toast.warn("No data available!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
       
        return; // Exit function early
      }

      let reportUrl = response.data;
      console.log("Response data:", response.data);
      if (reportUrl === "FILENOTFOUND") {
        toast.warn("Jrxml File Not Found...!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } 
     else if (reportUrl === "NOTFOUND") {
        toast.warn("Report File Not Found...!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        const reportLink =  BaseIPForPDF + `output/${reportUrl}`;
        window.open(reportLink, "_blank");
      }
    }}
    catch (error) {
      
      console.error("Error during API call:", error);
      toast.error("Error occurred while submitting data");
    }

    
  };

    //===============================================

  return (
    <div className="px-5 py-3">
      <div
        className="row mt-3 p-3  pt-3 mb-3 rounded"
        style={{ backgroundColor: '#e0efff' }}
      >
        <div className="col-12">
          <div className="row p-0 m-0">


            <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Rack Number</label>
              <Select
                value={rackNumber || undefined}
                onChange={(value) => {
                  setRackNumber(value)
                  handleRackChange(value)
                }}
                showSearch
                className="w-100"
                placeholder="Select Number"
                optionFilterProp="children"
              >
                {allRackNumber.map((rack) => (
                  <Option key={rack.rackNumberId} value={rack.rackNumberId}>
                    {rack.rackNumber}
                  </Option>
                ))}
              </Select>
              {errors.rackNumber && (
                <div className="errorField">{errors.rackNumber}</div>
              )}
            </div>

            <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Die Number</label>
              <Input
                readOnly type='number'
                style={{ backgroundColor: '#e9e9e9' }}
                value={dieNumber}
                onChange={(e) => setDieNumber(e.target.value)}
                maxLength={250}
              />
              {errors.dieNumber && (
                <div className="errorField">{errors.dieNumber}</div>
              )}
            </div>

             <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Die Sub Number</label>
              <Input
                readOnly type='number'
                style={{ backgroundColor: '#e9e9e9' }}
                value={dieSubNumber}
                onChange={(e) => setDieSubNumber(e.target.value)}
                maxLength={250}
              />
            </div>

            <div className="col-lg-3 py-1"></div>

            <div className="col-lg-8 py-1">
              <label className="labels">Item Name</label>
              <Select
                mode="default"
                value={itemName || undefined}
                onChange={handleItemNameChange}
                showSearch
                className="w-100"
                placeholder="Select Name"
                optionFilterProp="children"
              >
                {allItemName.map((name) => (
                  <Option key={name.id} value={name.id}>
                    {name.dieName} | {name.orderNumber} | {name.alloyName} | {name.temperName} | {name.length} -{' '} {name.unit == 1 ? 'FT' : name.unit == 2 ? 'MM' : 'INCH'} |  PCS:{name.totalPcs} | QTY:{name.qty} | {name.wtRange} 
                    
                  </Option>
                ))}
              </Select>
              {errors.itemName && (
                <div className="errorField">{errors.itemName}</div>
              )}
            </div>

            <div className="col-lg-4  py-1"></div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Alloy</label>
              <Input
                value={alloy}
                onChange={(e) => setAlloy(e.target.value)}
                placeholder="Enter Alloy"
                maxLength={250}
              />
              {errors.alloy && <div className="errorField">{errors.alloy}</div>}
            </div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Temper</label>
              <Input
                value={temper}
                onChange={(e) => setTemper(e.target.value)}
                placeholder="Enter Temper"
                maxLength={250}
              />
              {errors.temper && (
                <div className="errorField">{errors.temper}</div>
              )}
            </div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Length</label>
              <Input type='number'
                value={lengthSize}
                onChange={(e) => setLengthSize(e.target.value)}
                placeholder="Enter Length"
                maxLength={250}
              />
              {errors.lengthSize && (
                <div className="errorField">{errors.lengthSize}</div>
              )}
            </div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Unit</label>
              <Select
                value={unit || undefined}
                onChange={setUnit}
                showSearch
                className="w-100"
                placeholder="Select Unit"
                optionFilterProp="children"
              >
                {unitOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
              {errors.unit && <div className="errorField">{errors.unit}</div>}
            </div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Pcs [{pcsHead}]</label>
              <Input type='number'
                value={pcs}
                onChange={(e) => {
                  const value = e.target.value
                  setPcs(value)

                  // Recalculate weight range if net weight is available
                  if (netWeight && !isNaN(value) && !isNaN(netWeight)) {
                    const calculatedWeightRange = (
                      parseFloat(netWeight) / parseFloat(value)
                    ).toFixed(2)
                    setWeightRange(calculatedWeightRange)
                  } else {
                    setWeightRange('')
                  }
                }}
                placeholder="Enter Pcs"
                maxLength={250}
              />
              {errors.pcs && <div className="errorField">{errors.pcs}</div>}
            </div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Net Wt [{netWeightHead}]</label>
              <Input type='number'
                value={netWeight}
                onChange={(e) => {
                  const value = e.target.value
                  setNetWeight(value)

                  // Recalculate weight range if pcs is available
                  if (pcs && !isNaN(value) && !isNaN(pcs)) {
                    const calculatedWeightRange = (
                      parseFloat(value) / parseFloat(pcs)
                    ).toFixed(2)
                    setWeightRange(calculatedWeightRange)
                  } else {
                    setWeightRange('')
                  }
                }}
                placeholder="Enter Weight"
                maxLength={250}
              />

              {errors.netWeight && (
                <div className="errorField">{errors.netWeight}</div>
              )}
            </div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Gross Wt</label>
              <Input
                readOnly type='number'
                style={{ backgroundColor: '#e6e6e6' }}
                value={grossWeight}
                onChange={(e) => setGrossWeight(e.target.value)}
                maxLength={250}
              />
              {errors.grossWeight && (
                <div className="errorField">{errors.grossWeight}</div>
              )}
            </div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Wt Range</label>
              <Input type='number'
                value={weightRange}
                onChange={(e) => setWeightRange(e.target.value)}
                placeholder="Enter Weight"
                maxLength={250}
                readOnly
              />
              {errors.weightRange && (
                <div className="errorField">{errors.weightRange}</div>
              )}
            </div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Barcode Size</label>
              <Select
                value={barcodeSize || undefined}
                onChange={setBarcodeSize}
                showSearch
                className="w-100"
                placeholder="Select Size"
                optionFilterProp="children"
              >
                {barcodeOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
              {errors.barcodeSize && (
                <div className="errorField">{errors.barcodeSize}</div>
              )}
            </div>

            <div className="col-md-6 col-lg-2 py-1">
              <label className="labels">Allocation</label>
              <Select
                value={allocation || undefined}
                onChange={setAllocation}
                showSearch
                className="w-100"
                placeholder="Select Allocation"
                optionFilterProp="children"
              >
                {allocationOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
              {errors.allocation && (
                <div className="errorField">{errors.allocation}</div>
              )}
            </div>

            {/* <div className="col-md-6 col-lg-6 border pt-4">
              <table className="w-100">
                <thead>
                  <tr>
                    <th
                      style={{
                        border: '1px solid grey',
                        padding: '5px',
                        fontSize: '13px',
                        backgroundColor: '#e6e6e6',
                      }}
                    >
                      Customer Name
                    </th>
                    <th
                      style={{
                        border: '1px solid grey',
                        padding: '5px',
                        fontSize: '13px',
                        backgroundColor: '#e6e6e6',
                      }}
                    >
                      Color Name
                    </th>
                    <th
                      style={{
                        border: '1px solid grey',
                        padding: '5px',
                        fontSize: '13px',
                        backgroundColor: '#e6e6e6',
                      }}
                    >
                      Color Code
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style={{
                        border: '1px solid grey',
                        padding: '5px',
                        fontSize: '12px',
                      }}
                    >
                      {customerName}
                    </td>
                    <td
                      style={{
                        border: '1px solid grey',
                        padding: '5px',
                        fontSize: '12px',
                        backgroundColor: color,
                      }}
                    >
                      {colorName}
                    </td>
                    <td
                      style={{
                        border: '1px solid grey',
                        padding: '5px',
                        fontSize: '12px',
                      }}
                    >
                      {colorCode}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div> */}

            {allocation == '1' && (
              <>
              {/* <div className="col-md-6 col-lg-9 py-1">
                <label className="labels">Allocation Type</label>
                <Select
                  value={allocationType || undefined}
                  onChange={setAllocationType}
                  showSearch
                  className="w-100"
                  placeholder="Select AllocationType"
                  optionFilterProp="children"
                >
                  {allAllocationType.map((opt) => (
                    <Option key={opt.id} value={opt.id}>
                      {opt.dieNumber} | {opt.pendingOrder} | {opt.alloyName} |{' '}
                      {opt.temperName} | {opt.length} |{' '}
                      {opt.unit == 1 ? 'FT' : opt.unit == 2 ? 'MM' : 'INCH'} |{' '}
                      {opt.totalPcs} | {opt.qty} | {opt.wtRange}
                    </Option>
                  ))}
                </Select>
              </div> */}

              <div
                className="col-12 py-1 mt-3 shadow border rounded"
                style={{ backgroundColor: 'white' }}
              >
                <div className="col-12  px-lg-5"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <span style={{ fontSize: '14px' }}>
                      Show entries &nbsp;
                    </span>
                    <Select
                      defaultValue={pageSize2}
                      onChange={handlePageSizeChange2}
                      style={{ width: 120, textAlign: 'center' }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-lg-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch2(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>

                </div>

                <div style={{ backgroundColor: 'white' }}>
                  <Table
                    bordered
                    style={{ padding: '0px 20px', overflowX: 'auto',cursor: 'pointer' }}
                    columns={columns2}
                    dataSource={filteredData2}
                    pagination={{
                      pageSize: pageSize2,
                      total: totalEntries2,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage2,
                      onChange: (page) => setCurrentPage2(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components2}
                     onRow={(record) => ({
                      onClick: () => {
                        if (allocationType === record.id) {
                          setAllocationType(null);
                        } else {
                          setAllocationType(record.id);
                        }                        
                      },
                    })}
                    rowClassName={(record) =>
                    allocationType === record.id ? 'selected-row' : ''
                    }
                  />
                </div>
              </div>

              </>
            )}

            <div className="col-12 text-start pt-3">
              <Button
                type="submit"
                className="CancelBtn mx-1"
                onClick={handlePackingCancel}
              >
                Cancel
              </Button>
             
              <Button
                type="submit"
                className="SubmitBtn mx-1"
                onClick={handlePackingSubmit}
              >
                Submit
              </Button>
            
            </div>
          </div>
        </div>
      </div>

      <div
        className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
        style={{ backgroundColor: '#e0efff' }}
      >
        <div className="col-12">
          <div className="row p-0 m-0">
            <div className="col-12 pb-3">
              <h5>
                <u>Today's Packing Details Record</u> -{' '}
              </h5>
            </div>

            <div className="row  mb-3">
              <div
                className="col-12 py-3 shadow border rounded"
                style={{ backgroundColor: 'white' }}
              >
                <div className="col-12 py-3 px-lg-5"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <span style={{ fontSize: '14px' }}>
                      Show entries &nbsp;
                    </span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: 'center' }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-lg-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>

                </div>

                <div style={{ backgroundColor: 'white' }}>
                  <Table
                    bordered
                    style={{ padding: '0px 20px', overflowX: 'auto' }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>

            </div>

          </div>
        </div>

          <Modal
              title="Edit Packing"
              open={isModalVisible}
              onCancel={() => {
                 setIsModalVisible(false)
                 handlePackingCancel2()
                 }}
              onOk={handlePackingUpdate}
              okText="Save Changes"
              width={600}
            >
          <div className="row">

            <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Packing ID</label>
              <Input type='number'
                value={packingIdM}
                onChange={(e) => setPackingIdM(e.target.value)}
                placeholder="Enter Id"
                maxLength={250}
                style={{backgroundColor:"#e9e9e9"}}
                readOnly
              />
            </div>

            <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Length</label>
              <Input type='number'
                value={lengthSizeM}
                onChange={(e) => setLengthSizeM(e.target.value)}
                placeholder="Enter Length"
                maxLength={250}
              />
               {errors.lengthSizeM && (<div className="errorField">{errors.lengthSizeM}</div>)}
            </div>

            <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Unit</label>
              <Select
                value={unitM || undefined}
                onChange={setUnitM}
                showSearch
                className="w-100"
                placeholder="Select Unit"
                optionFilterProp="children"
              >
                {unitOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
               {errors.unitM && (<div className="errorField">{errors.unitM}</div>)}
            </div>

            <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Pcs</label>
              <Input type='number'
                value={pcsM}
                onChange={(e) => {
                  const value = e.target.value
                  setPcsM(value)

                  // Recalculate weight range if net weight is available
                  if (netWeightM && !isNaN(value) && !isNaN(netWeightM)) {
                    const calculatedWeightRange = (
                      parseFloat(netWeightM) / parseFloat(value)
                    ).toFixed(2)
                    setWeightRangeM(calculatedWeightRange)
                  } else {
                    setWeightRangeM('')
                  }
                }}
                placeholder="Enter Pcs"
                maxLength={250}
              />
               {errors.pcsM && (<div className="errorField">{errors.pcsM}</div>)}
            </div>

            <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Alloy</label>
              <Input
                value={alloyM}
                onChange={(e) => setAlloyM(e.target.value)}
                placeholder="Enter Alloy"
                maxLength={250}
              />
               {errors.alloyM && (<div className="errorField">{errors.alloyM}</div>)}
            </div>

            <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Temper</label>
              <Input
                value={temperM}
                onChange={(e) => setTemperM(e.target.value)}
                placeholder="Enter Temper"
                maxLength={250}
              />
               {errors.temperM && (<div className="errorField">{errors.temperM}</div>)}
            </div>

            <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Net Weight</label>
              <Input type='number'
                value={netWeightM}
                onChange={(e) => {
                  const value = e.target.value
                  setNetWeightM(value)

                  // Recalculate weight range if pcs is available
                  if (pcsM && !isNaN(value) && !isNaN(pcsM)) {
                    const calculatedWeightRange = (
                      parseFloat(value) / parseFloat(pcsM)
                    ).toFixed(2)
                    setWeightRangeM(calculatedWeightRange)
                  } else {
                    setWeightRangeM('')
                  }
                }}
                placeholder="Enter Weight"
                maxLength={250}
              />
              {errors.netWeightM && (<div className="errorField">{errors.netWeightM}</div>)}
            </div>

             <div className="col-md-6 col-lg-3 py-1">
              <label className="labels">Weight Range</label>
              <Input type='number'
                value={weightRangeM}
                onChange={(e) => setWeightRangeM(e.target.value)}
                placeholder="Enter Weight"
                maxLength={250}
                style={{backgroundColor:"#e9e9e9"}}
                readOnly
              />
            </div>

          </div>

            </Modal>


      </div>

      <div
        className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
        style={{ backgroundColor: '#e0efff' }}
      >
        <div className="col-12">
          <div className="row p-0 m-0">
            <div className="col-12 pb-3 p-0" style={{display:"flex",justifyContent:"space-between"}}>
              <h5>
                <u>Recent Packing Records</u> -{' '}
              </h5>

              {filteredData1.length > 10 && (
                <div className="text-center p-0 me-4">
                  {!viewMoreClicked ? (
                    <button className="btn btn-primary" onClick={handleViewMoreClick}>
                      View More
                    </button>
                  ) : (
                    <button className="btn btn-secondary" onClick={handleShowLessClick}>
                      Show Less
                    </button>
                  )}
                </div>
              )}

            </div>

            <div className="row  mb-3">
              <div
                className="col-12 py-3 shadow border rounded"
                style={{ backgroundColor: 'white' }}
              >

                {/* {!viewMoreClicked && filteredData1.length > 10 && (
                  <div className="text-center mt-3">
                    <button className="btn btn-primary" onClick={handleViewMoreClick}>
                      View More
                    </button>
                  </div>
                )} */}


                <div
                  className="col-12 py-3 px-lg-5"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <span style={{ fontSize: '14px' }}>
                      Show entries &nbsp;
                    </span>
                    <Select
                      defaultValue={pageSize1}
                      onChange={handlePageSizeChange1}
                      style={{ width: 120, textAlign: 'center' }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-lg-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch1(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: 'white' }}>
                  {/* <Table
                    bordered
                    style={{ padding: '0px 20px', overflowX: 'auto' }}
                    columns={columns1}
                    dataSource={filteredData1}
                    pagination={{
                      pageSize: pageSize1,
                      total: totalEntries1,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage1,
                      onChange: (page) => setCurrentPage1(page),
                     }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components1}
                  /> */}

                  <Table
                      bordered
                      style={{ padding: '0px 20px', overflowX: 'auto' }}
                      columns={columns1}
                      dataSource={displayedData1}
                      pagination={
                        viewMoreClicked
                          ? {
                              pageSize: pageSize1,
                              total: filteredData1.length,
                              showTotal: (total, range) =>
                                `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                              current: currentPage1,
                              onChange: (page) => setCurrentPage1(page),
                            }
                          : false
                      }
                      showSorterTooltip={false}
                      rowKey={(record) => record.id}
                      components={components1}
                    />


                </div>
              </div>

            </div>
            
          </div>
        </div>
      </div>

         <div
        className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
        style={{ backgroundColor: '#e0efff' }}
      >
        <div className="col-12">
          <div className="row p-0 m-0">
            <div className="col-12 pb-3">
              <h5>
                <u>RELEASE RACK</u> -{' '}
              </h5>
            </div>

            <div className="col-12 py-1">
              <div className="row">
                <div className="col-12 col-lg-2"></div>
                <div className="col-12 col-lg-2 p-0">
                  <label className="labels">Rack already in use</label>
                </div>
                <div className="col-12 col-lg-3">
                  <Select
                    value={rackRelease || undefined}
                    onChange={(value) => {
                      setRackRelease(value)
                    }}
                    showSearch
                    className="w-100"
                    placeholder="Select Rack Number"
                    optionFilterProp="children"
                  >
                    {allRackNumber.map((rack) => (
                      <Option key={rack.rackNumberId} value={rack.rackNumberId}>
                        {rack.rackNumber}
                      </Option>
                    ))}
                  </Select>
                  {errors.rackRelease && (
                    <div className="errorField">{errors.rackRelease}</div>
                  )}
                </div>
                <div className="col-12 col-lg-4 pt-2 pt-lg-0">
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleReleaseRack}
                  >
                    Release
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

    </div>
  )
}

export default Packing
